<!--
 * @FilePath: /src/views/contact.vue
 * @Description: 联系我们
-->
<template>
  <div>
    <header-view></header-view>

    <div id="content" class="content-box">
      <div class="content-banner"></div>
      <div class="table-content">
        <div class="table-box f-cb">
          <div id="contact">
            <ul id="contact_toggle" class="nav f-fl">
              <li class="title">
                <h2>联系我们</h2>
                <span class="tip"> CONTACT US</span>
              </li>
              <li class="active">联系我们</li>
            </ul>
            <div id="contact_container">
              <div class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">联系我们</h3>
                  <span class="des f-fr">
                    您的位置：首页 > <span>联系我们</span>
                  </span>
                </div>

                <div class="contact-us">
                  <div class="contact-us-1 contact-us-module">
                    <p class="contact-us-title">
                      <img src="../assets/images/location2.png" alt="" />
                      <span>上海中心</span>
                    </p>
                    <p class="contact-us-line"></p>

                    <div class="contact-us-content">
                      <p>办公地址：张江高科技园区核心区，约1900平方</p>
                      <p>联系人员：罗明权</p>
                      <p>联系邮箱：mingquan.luo@cf-fis.com</p>
                      <p>招聘热线：18326115160</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
import HeaderView from '@/components/header.vue'
import FooterView from '@/components/footer.vue'

export default {
  name: 'contactView',

  components: { HeaderView, FooterView }
}
</script>

<style lang="stylus">
@import '../styles/content.styl'

#contact {
  .contact-us {
    text-align: center;
  }

  .contact-us-1 {
    display: inline-block;
    margin: 0 auto;
  }

  .contact-us-content {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contact.vue